import {Nullish} from 'shared/web';

export interface GetLocalActionNoteRequest {
  vehicleId: string | Nullish;
}

export interface GetLocalActionNoteResponse {
  local_action_note_text: string | null;
}
